import { render, staticRenderFns } from "./couponMarketList.vue?vue&type=template&id=da69fcf2&scoped=true"
import script from "./couponMarketList.vue?vue&type=script&lang=js"
export * from "./couponMarketList.vue?vue&type=script&lang=js"
import style0 from "./couponMarketList.vue?vue&type=style&index=0&id=da69fcf2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da69fcf2",
  null
  
)

export default component.exports